export default __webpack_public_path__ + "static/media/boxtype3.bccf8b85.JPG";